// src/LoginPage.js

import {React, useState, useEffect} from 'react';
import { Form, Input, Button, Checkbox, Card, Typography } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { saveUserData} from '../User_Data';

const LoginPage = () => {
  const mainUrl                       = "https://chatbot-summary-deployment-dot-fartech-yvqj.et.r.appspot.com/";
  const navigate = useNavigate();
  const [result, setResult] = useState(null);

  useEffect(() => {
    // Check if the result is not null and has valid data
    if (result != null) {
      if (result.user_type === "Customer") {
        navigate('/customer_dashboard');
      } else if (result.user_type === "Admin") {
        navigate('/dashboard');
      }
    } else {
      // Display error message or handle other cases
    }

  }, [result]); // Trigger the effect when the 'result' state changes

    
  const onFinish = async (values) => {
    try {
      const response = await fetch(`${mainUrl}/authenticateUser?username=${encodeURIComponent(values.username)}&password=${encodeURIComponent(values.password)}`);
      const data = await response.json();

      setResult(data);
      saveUserData(data);

      console.log(data)
    } catch (error) {
      console.error('Error during authentication:', error.message);
      // Handle other errors if needed
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '98vh' }}>
      <Card style={{ width: 400, padding: 20, boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' }}>
        <Typography.Title level={3} style={{ textAlign: 'center', marginBottom: 20 }}>Login</Typography.Title>
        <Form
          name="login-form"
          initialValues={{ remember: true }}
          onFinish={onFinish}
        >
        <Form.Item
          name="username"
          rules={[{ required: true, message: 'Please input your username!' }]}
        >
          <Input placeholder="Username" />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input.Password placeholder="Password" />
        </Form.Item>

        <Form.Item>
          <Form.Item name="remember" valuePropName="checked" noStyle>
            <Checkbox>Remember me</Checkbox>
          </Form.Item>

          <a href="/forgot-password" style={{ float: 'right' }}>
            Forgot password
          </a>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
            Log in
          </Button>
        </Form.Item>
      </Form>
      </Card>
    </div>
  );
};

export default LoginPage;
